module.exports = __webpack_public_path__ + "static/media/ic_archive.0abeec56.svg";